import { render } from "./GroupProductsModal.vue?vue&type=template&id=573c8e46"
import script from "./GroupProductsModal.vue?vue&type=script&lang=js"
export * from "./GroupProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__